import React from 'react';
import FadeIn from '../components/ui/FadeIn';

const Impressum = () => {
  return (
    <div className="pt-32 pb-20 bg-brand-cream min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <FadeIn>
          <h1 className="text-4xl font-serif mb-12 border-b border-brand-rose pb-6">Impressum</h1>
          
          <div className="prose prose-brand max-w-none space-y-8 text-brand-text">
            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">Angaben gemäß § 5 TMG</h2>
              <p>
                Rukiye Amini<br />
                glowconsulting.de<br />
                Axel-Springer-Platz 3<br />
                20355 Hamburg
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">Kontakt</h2>
              <p>
                E-Mail: hallo@glowconsulting.de
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">Redaktionell verantwortlich</h2>
              <p>
                Rukiye Amini<br />
                Axel-Springer-Platz 3<br />
                20355 Hamburg
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-brand-accent hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>.
              </p>
            </section>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};

export default Impressum;